import script from "./form4View.vue?vue&type=script&setup=true&lang=js"
export * from "./form4View.vue?vue&type=script&setup=true&lang=js"

import "./form4View.vue?vue&type=style&index=0&id=84eff1ee&lang=css"

const __exports__ = script;

export default __exports__